import { useState, useEffect } from 'react';
export function useIsMobile(bp = 768) {
  const [m, setM] = useState(() => window.innerWidth < bp);
  useEffect(() => {
    const h = () => setM(window.innerWidth < bp);
    window.addEventListener('resize', h);
    // V35: 회전 시 즉시 반영 (일부 구형 모바일 대비, resize와 함께 발화)
    window.addEventListener('orientationchange', h);
    return () => {
      window.removeEventListener('resize', h);
      window.removeEventListener('orientationchange', h);
    };
  }, [bp]);
  return m;
}
